export default __webpack_public_path__ + "static/media/filledStar.b538b5a3.svg";